import { createSlice } from "@reduxjs/toolkit";
import { fetchTags } from "../thunks/tagsThunk";

const initialState = {
    tags: [],
    isLoadingTags: false,
    error: null,
};

const tagsSlice = createSlice({
    name: "tags",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTags.pending, (state) => {
                state.isLoadingTags = true;
                state.error = null;
            })
            .addCase(fetchTags.fulfilled, (state, action) => {
                state.isLoadingTags = false;
                state.tags = action.payload;
            })
            .addCase(fetchTags.rejected, (state, action) => {
                state.isLoadingTags = false;
                state.error = action.error.message;
            });
    },
});

export default tagsSlice.reducer;